import { FC } from 'react';
import { PriceType, usePriceLabel } from '@edikk-edikk/country-frontend';
import modelDetailParameterCss from '../../assets/model-detail/model-detail-parameter.module.scss';

type PropsType = {
  price: string;
  type: PriceType;
};

const Price: FC<PropsType> = ({
  price,
  type,
}) => {
  const label = usePriceLabel(type);

  return (
    <div className={modelDetailParameterCss.modelDetailParameter}>
      <div className={modelDetailParameterCss.modelDetailParameter__label}>
        {label}
      </div>
      <div className={modelDetailParameterCss.modelDetailParameter__value}>
        <div className={modelDetailParameterCss.modelDetailParameter__price}>
          {price}
        </div>
      </div>
    </div>
  );
};

export { Price };
